import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import devBio from '../../utils/devBio';
import designBio from '../../utils/desBio';

const About = () => {

    const devMode = useSelector(state => state.devMode);
    const [bio, setBio] = useState({
        description: '',
        tools: [],
        image: '',
        webpImage: '',
        caption: ''
    });

    useEffect(() => {
        if (devMode) {
            setBio(devBio);
        } else {
            setBio(designBio);
        }
    }, [devMode]);

    const { description, tools, image, caption } = bio;

    // sync the avatar with the live GitHub profile picture (updates when you
    // change it on GitHub); falls back to the local image if unreachable
    const githubUsername = process.env.REACT_APP_GITHUB_USERNAME || 'k4ran909';
    const githubAvatar = `https://github.com/${githubUsername}.png?size=300`;

    return (
        <section className={`about page ${devMode ? 'dev' : 'des'}`} id='about'>

            <h2>About Me</h2>

            <div className='about-content'>
                <figure className='about-image-container'>
                    <img
                        loading="lazy"
                        className='avatar'
                        src={githubAvatar}
                        onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = process.env.PUBLIC_URL + image; }}
                        alt={`${githubUsername} GitHub avatar`}
                        width="300"
                        height="300"
                    />
                    <figcaption className='about-caption'>{caption}</figcaption>
                </figure>

                <article className='about-text-container'>
                    <p className='about-text'>
                        {description}
                    </p>
                    <ul className='about-tools'>
                        {tools.map(tool => <li key={tool} className='label'>{tool}</li>)}
                    </ul>
                </article>
            </div>
        </section>
    );
}

export default About;